import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Button, Modal, Col, Row, Spinner } from "react-bootstrap";
import _ from "lodash";
import SwalMessage from "../_Components/SwalMessage";
import ApiAmusementServiceReserveItem from "../../../core/api/api.amusementServiceReserveItem";
import { useForm, Controller } from "react-hook-form";
import ApiAmusementService from "../../../core/api/api.amusementService";
import { NumericFormat, PatternFormat } from "react-number-format";
import Swal from "sweetalert2";
import SelectComponent from "../_Components/ReactSelectComponent";

const supplierSettlementTypeEnum = [
  { value: 1, label: "تسویه در وضعیت بلیط رزرو" },
  { value: 2, label: "تسویه در وضعیت بلیط استفاده شده" },
];
const issueTicketTypeEnum = [
  { value: 1, label: "صدور بلیط خارج از سامانه" },
  { value: 2, label: "صدور بلیط توسط سامانه" },
];

const GroupEditingModal = ({
  showModalGroupEditing,
  setShowModalGroupEditing,
  suppliers,
  selectedItem
}) => {
  const [services, setServices] = useState([]);
  const [enabledFields, setEnabledFields] = useState({
    amusementServiceId: false,
    originalPrice: false,
    price: false,
    minimumReserveCountPerDay: false,
    defaultReserveCountPerDay: false,
    reservationExpirationTime: false,
    executionTime: false,
    reservationByPhone: false,
    supplierSettlementPrice: false,
    supplierId: false,
    supplierSettlementType: false,
    issueTicketType: false,
    supplierAutoSettlement: false,
    isActive: false
  });
  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    reset,
    setValue,
    getValues,
  } = useForm({
    defaultValues: {
      id: 0,
      defaultReserveCountPerDay: 10,
      reservationExpirationTime: "23:59",
      isDisplay: true,
      supplierAutoSettlement: true,
      isActive: true,
      supplierSettlementType: { value: 2, label: "تسویه در وضعیت بلیط استفاده شده" },
      issueTicketType: { value: 1, label: "صدور بلیط خارج از سامانه " },
      amusementServiceId: null,
      supplierId: null,
    },
  });
  const [errorForSupplierSettlementPrice, setErrorForSupplierSettlementPrice] = useState(false);
  // Fetch all services and suppliers
  useEffect(() => {
    const fetchServices = async () => {
      try {
        const services = await ApiAmusementService.getAllServices();
        if (!_.isEmpty(services)) {
          setServices(services);
        }
      } catch (error) {
      }
    };

    fetchServices();
  }, []);
  const handleToggleField = (fieldName) => {
    setEnabledFields(prev => ({
      ...prev,
      [fieldName]: !prev[fieldName]
    }));
  };

  const handleClose = () => {
    setShowModalGroupEditing(false);
  };

  const onSubmit = async (data) => {
    try {
      // پردازش فقط فیلدهای فعال
      if (enabledFields.originalPrice) {
        data.originalPrice = data.originalPrice && data.originalPrice.length > 0
          ? data.originalPrice.replaceAll(" ", "").replaceAll(",", "")
          : data.originalPrice;
      }

      if (enabledFields.price) {
        data.price = data.price && data.price.length > 0
          ? data.price.replaceAll(" ", "").replaceAll(",", "")
          : data.price;
      }
      if (enabledFields.supplierId) {
        data.supplierId = data.supplierId?.value;

        if (data.supplierId !== null && !data.supplierSettlementPrice) {
          setErrorForSupplierSettlementPrice(true);
          return;
        }
        if (data.supplierId !== null && Number(data.supplierSettlementPrice) === 0) {
          const resultSweetAlert = await Swal.fire({
            // title: "تایید عملیات درج",
            text: "تامین کننده تفریح انتخاب شده و مبلغ پرداختی به تامین کننده صفر می باشد. در صورت مغایرت مبلغ پرداخت به تامین کننده جهت جلوگیری از بروز مشکل آن را تغییر دهید در غیراین صورت روی دکمه تایید کلیک نمایید",
            showDenyButton: true,
            showCancelButton: false,
            icon: "question",
            confirmButtonText: "تایید",
            denyButtonText: "انصراف",
            // cancelButtonText: "انصراف",
            customClass: {
              actions: "my-actions",
              //cancelButton: "order-1 right-gap btn btn-secondary px-3",
              confirmButton: "order-2 btn btn-success px-5",
              denyButton: "order-3 btn btn-danger px-5",
            },
            focusCancel: true
          });

          if (!resultSweetAlert.isConfirmed) {
            return;
          }
        }
      }
      if (enabledFields.supplierSettlementPrice) {
        data.supplierSettlementPrice = data.supplierSettlementPrice && data.supplierSettlementPrice.length > 0
          ? data.supplierSettlementPrice.replaceAll(" ", "").replaceAll(",", "")
          : data.supplierSettlementPrice;
      }
      if (enabledFields.supplierSettlementType) {
        data.supplierSettlementType = data?.supplierSettlementType?.value;
      }

      if (enabledFields.issueTicketType) {
        data.issueTicketType = data?.issueTicketType?.value;
      }

      if (enabledFields.amusementServiceId) {
        data.amusementServiceId = data.amusementServiceId?.value;
      }



      if (enabledFields.minimumReserveCountPerDay) {
        data.minimumReserveCountPerDay = +data.minimumReserveCountPerDay;
      }

      if (enabledFields.originalPrice && enabledFields.price) {
        if (Number(data.originalPrice) < Number(data.price)) {
          SwalMessage({
            title: "قیمت نمی تواند بیشتر از قیمت اصلی آیتم باشد.",
            iSsuccess: false,
            timer: 5000
          });
          return;
        }
      }

      // ایجاد یک شیء جدید فقط با فیلدهای فعال
      const submittedData = Object.keys(data).reduce((acc, key) => {
        if (enabledFields[key]) {
          acc[key] = data[key];
        }
        return acc;
      }, {});

      submittedData.ids = selectedItem;
      // ارسال به API
      ApiAmusementServiceReserveItem.updateAmusementServiceReserveItemInGrouping(submittedData)
        .then(response => {
          if (response.succeeded == true) document.getElementById("submitButton").click();
          SwalMessage({ title: response.message, iSsuccess: response.succeeded });
          setShowModalGroupEditing(false);
        })
        .catch(error => {
        });

    } catch (error) {
      SwalMessage({
        title: "خطا در پردازش فرم",
        iSsuccess: false
      });
    }
  };

  const selectStyles = {
    menu: (base) => ({
      ...base,
      zIndex: 10000,
    }),
  };
  const handleChangeIsNumber = (event, onChange) => {
    const value = event.target.value;
    const label = event.target.closest(".MuiTextField-root")?.querySelector("label")?.innerHTML
    // فقط مقادیر عددی بزرگتر از 0 مجاز باشند
    if (/^[0-9]\d*$|^$/.test(value)) {
      // فیلد تماس تلفنی باید 11 رقم باشد
      if (label == "تماس تلفنی" && (value.length > 11 || value.length < 0)) return
      onChange(value); // مقدار ورودی را به‌روزرسانی می‌کنیم
    }
  };
  return (
    <div>
      <div className="card-body pt-3 pb-0">
        <Modal centered show={showModalGroupEditing} onHide={handleClose}>
          <form id="form" onSubmit={handleSubmit(onSubmit)}>
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter"> ویرایش گروهی</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Col xs="12">
                <Row>
                  <Col xs="12" className="d-flex align-items-center">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={enabledFields.amusementServiceId}
                          onChange={() => handleToggleField('amusementServiceId')}
                          color="primary"
                        />
                      }
                      title="فعال کردن"
                      labelPlacement="start"
                    />
                    <div style={{ flex: 1 }}>
                      <Controller
                        name="amusementServiceId"
                        control={control}
                        rules={{ required: enabledFields.amusementServiceId }}
                        render={({ field: { onChange } }) => (
                          <SelectComponent
                            name="service"
                            style={selectStyles}
                            inputId="react-select-with-search"
                            className="w-100 mt-2"
                            variant="outlined"
                            size="small"
                            placeholder="انتخاب تفریح"
                            isDisabled={!enabledFields.amusementServiceId}
                            TextFieldProps={{
                              label: "Services2",
                              InputLabelProps: {
                                htmlFor: "react-select-multiple",
                                shrink: true,
                              },
                            }}
                            options={services?.map((item) => ({
                              value: item.id,
                              label: item.name,
                            }))}
                            value={getValues("amusementServiceId") || ""}
                            onChange={onChange}
                          />
                        )}
                      />
                    </div>
                  </Col>
                  <Col xs="12" className="d-flex align-items-center">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={enabledFields.originalPrice}
                          onChange={() => handleToggleField('originalPrice')}
                          color="primary"
                        />
                      }
                      title="فعال و قابل ویرایش"
                      labelPlacement="start"
                    />
                    <div style={{ flex: 1 }}>
                      <Controller
                        name="originalPrice"
                        control={control}
                        rules={{ required: enabledFields.originalPrice }}
                        render={({ field: { onChange, value } }) => (
                          <NumericFormat
                            customInput={TextField}
                            label="قیمت اصلی"
                            margin="normal"
                            type="search"
                            variant="outlined"
                            size="small"
                            disabled={!enabledFields.originalPrice}
                            value={value || ""}
                            onChange={onChange}
                            thousandSeparator=","
                            onKeyDown={(e) => {
                              if (e.key === "Escape") {
                                e.stopPropagation()
                              }
                            }}
                          />
                        )}
                      />
                      {errors.originalPrice && enabledFields.originalPrice && (
                        <div className="mt-2 pl-4 text-danger">**لطفا قیمت را وارد نمایید</div>
                      )}
                    </div>
                  </Col>
                  <Col xs="12" className="d-flex align-items-center">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={enabledFields.price}
                          onChange={() => handleToggleField('price')}
                          color="primary"
                        />
                      }
                      title="فعال و قابل ویرایش"
                      labelPlacement="start"
                    />
                    <div style={{ flex: 1 }}>
                      <Controller
                        name="price"
                        control={control}
                        rules={{ required: enabledFields.price }}
                        render={({ field: { onChange, value } }) => (
                          <NumericFormat
                            customInput={TextField}
                            label="قیمت"
                            type="search"
                            margin="normal"
                            variant="outlined"
                            size="small"
                            disabled={!enabledFields.price}
                            value={value || ""}
                            onChange={onChange}
                            thousandSeparator=","
                            onKeyDown={(e) => {
                              if (e.key === "Escape") {
                                e.stopPropagation()
                              }
                            }}
                          />
                        )}
                      />
                      {errors.price && enabledFields.price && <div class="mt-2 pl-4 text-danger">**لطفا قیمت را وارد نمایید</div>}
                    </div>
                  </Col>
                  <Col xs="12" className="d-flex align-items-center">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={enabledFields.minimumReserveCountPerDay}
                          onChange={() => handleToggleField('minimumReserveCountPerDay')}
                          color="primary"
                        />
                      }
                      title="فعال و قابل ویرایش"
                      labelPlacement="start"
                    />
                    <div style={{ flex: 1 }}>
                      <Controller
                        name="minimumReserveCountPerDay"
                        control={control}
                        render={({ field }) => (
                          <TextField
                            label="حداقل تعداد"
                            type="text"
                            margin="normal"
                            variant="outlined"
                            size="small"
                            disabled={!enabledFields.minimumReserveCountPerDay}
                            value={field.value || ""}
                            onInput={(e) => handleChangeIsNumber(e, field.onChange)}
                          />
                        )}
                      />
                    </div>
                  </Col>
                  <Col xs="12" className="d-flex align-items-center">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={enabledFields.defaultReserveCountPerDay}
                          onChange={() => handleToggleField('defaultReserveCountPerDay')}
                          color="primary"
                        />
                      }
                      title="فعال و قابل ویرایش"
                      labelPlacement="start"
                    />
                    <div style={{ flex: 1 }}>
                      <Controller
                        name="defaultReserveCountPerDay"
                        control={control}
                        rules={{
                          required: enabledFields.defaultReserveCountPerDay
                        }}
                        render={({ field }) => (
                          <TextField
                            label="ظرفیت روزانه"
                            type="text"
                            margin="normal"
                            variant="outlined"
                            size="small"
                            disabled={!enabledFields.defaultReserveCountPerDay}
                            {...field}
                            onInput={(e) => handleChangeIsNumber(e, field.onChange)}
                          />
                        )}
                      />
                    </div>
                    {errors.defaultReserveCountPerDay && enabledFields.defaultReserveCountPerDay && (
                      <div class="mt-2 pl-4 text-danger">**لطفاظرفیت روزانه را وارد نمایید</div>
                    )}
                  </Col>
                  <Col xs="12" className="d-flex align-items-center">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={enabledFields.reservationExpirationTime}
                          onChange={() => handleToggleField('reservationExpirationTime')}
                          color="primary"
                        />
                      }
                      title="فعال و قابل ویرایش"
                      labelPlacement="start"
                    />
                    <div style={{ flex: 1 }}>
                      <Controller
                        name="reservationExpirationTime"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                          <PatternFormat
                            customInput={TextField}
                            label="ساعت اتمام فروش"
                            size="small"
                            type="search"
                            onKeyDown={(e) => {
                              if (e.key === "Escape") {
                                e.stopPropagation()
                              }
                            }}
                            disabled={!enabledFields.reservationExpirationTime}
                            margin="normal"
                            value={value || ""}
                            variant="outlined"
                            onChange={onChange}
                            placeholder="00:00"
                            format="##:##"
                            allowEmptyFormatting={false}
                            defaultValue="23:59"
                          />
                        )}
                      />
                    </div>
                  </Col>
                  <Col xs="12" className="d-flex align-items-center">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={enabledFields.executionTime}
                          onChange={() => handleToggleField('executionTime')}
                          color="primary"
                        />
                      }
                      title="فعال و قابل ویرایش"
                      labelPlacement="start"
                    />
                    <div style={{ flex: 1 }}>
                      <Controller
                        name="executionTime"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                          <PatternFormat
                            customInput={TextField}
                            label="زمان انجام برنامه"
                            size="small"
                            type="search"
                            onKeyDown={(e) => {
                              if (e.key === "Escape") {
                                e.stopPropagation()
                              }
                            }}
                            disabled={!enabledFields.executionTime}
                            margin="normal"
                            value={value || ""}
                            variant="outlined"
                            onChange={onChange}
                            placeholder="00:00"
                            format="##:##"
                            allowEmptyFormatting={false}
                            defaultValue="23:59"
                          />
                        )}
                      />
                    </div>
                  </Col>
                  <Col xs="12" className="d-flex align-items-center">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={enabledFields.reservationByPhone}
                          onChange={() => handleToggleField('reservationByPhone')}
                          color="primary"
                        />
                      }
                      title="فعال و قابل ویرایش"
                      labelPlacement="start"
                    />
                    <div style={{ flex: 1 }}>
                      <Controller
                        name="reservationByPhone"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                          <TextField
                            label="تماس تلفنی"
                            margin="normal"
                            variant="outlined"
                            size="small"
                            disabled={!enabledFields.reservationByPhone}
                            value={value || ""}
                            onInput={(e) => handleChangeIsNumber(e, onChange)}
                          />
                        )}
                      />
                    </div>
                  </Col>
                  <Col xs="12" className="d-flex align-items-center">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={enabledFields.supplierId}
                          onChange={() => handleToggleField('supplierId')}
                          color="primary"
                        />
                      }
                      title="فعال کردن"
                      labelPlacement="start"
                    />
                    <div style={{ flex: 1 }}>
                      <Controller
                        name="supplierId"
                        control={control}
                        render={({ field: { onChange } }) => (
                          <SelectComponent
                            name="supplierId"
                            style={selectStyles}
                            className="w-100 mt-5"
                            variant="outlined"
                            size="small"
                            isDisabled={!enabledFields.supplierId}
                            placeholder="تامین کننده"
                            TextFieldProps={{
                              label: "Supplier",
                              InputLabelProps: {
                                htmlFor: "react-select-multiple",
                                shrink: true,
                              },
                            }}
                            options={suppliers?.map((item) => ({
                              value: item.id,
                              label: item.companyName,
                            }))}
                            value={getValues("supplierId") || ""}
                            onChange={onChange}
                          />
                        )}
                      />
                    </div>
                  </Col>
                  <Col xs="12" className="d-flex align-items-center">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={enabledFields.supplierSettlementPrice}
                          onChange={() => handleToggleField('supplierSettlementPrice')}
                          color="primary"
                        />
                      }
                      title="فعال و قابل ویرایش"
                      labelPlacement="start"
                    />
                    <div style={{ flex: 1 }}>
                      <Controller
                        name="supplierSettlementPrice"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                          <NumericFormat
                            customInput={TextField}
                            label="قیمت تسویه با تامین کننده"
                            margin="normal"
                            variant="outlined"
                            type="search"
                            size="small"
                            disabled={!enabledFields.supplierSettlementPrice}
                            onChange={onChange}
                            value={value}
                            thousandSeparator=","
                            onKeyDown={(e) => {
                              if (e.key === "Escape") {
                                e.stopPropagation()
                              }
                            }}
                          />
                        )}
                      />
                    </div>
                    {errorForSupplierSettlementPrice && (
                      <div className="text-danger">**قیمت تسویه با تامین کننده را وارد کنید</div>
                    )}
                  </Col>
                  <Col xs="12" className="d-flex align-items-center">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={enabledFields.supplierSettlementType}
                          onChange={() => handleToggleField('supplierSettlementType')}
                          color="primary"
                        />
                      }
                      title="فعال و قابل ویرایش"
                      labelPlacement="start"
                    />
                    <div style={{ flex: 1 }}>
                      <Controller
                        name="supplierSettlementType"
                        control={control}
                        render={({ field: { onChange } }) => (
                          <SelectComponent
                            name="supplierSettlementType"
                            className="w-100 mt-2"
                            variant="outlined"
                            size="small"
                            isDisabled={!enabledFields.supplierSettlementType}
                            placeholder="نحوه تسویه با تامین کننده"
                            options={supplierSettlementTypeEnum}
                            value={getValues("supplierSettlementType") || ""}
                            onChange={onChange}
                          />
                        )}
                      />
                    </div>
                  </Col>

                  <Col xs="12" className="d-flex align-items-center">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={enabledFields.issueTicketType}
                          onChange={() => handleToggleField('issueTicketType')}
                          color="primary"
                        />
                      }
                      title="فعال و قابل ویرایش"
                      labelPlacement="start"
                    />
                    <div style={{ flex: 1 }}>
                      <Controller
                        name="issueTicketType"
                        control={control}
                        render={({ field: { onChange } }) => (
                          <SelectComponent
                            name="issueTicketType"
                            className="w-100 mt-5"
                            variant="outlined"
                            size="small"
                            isDisabled={!enabledFields.issueTicketType}
                            placeholder="نوع صدور بلیط"
                            options={issueTicketTypeEnum}
                            value={getValues("issueTicketType") || ""}
                            onChange={onChange}
                          />
                        )}
                      />
                    </div>
                  </Col>
                  <Col xs="12" className="d-flex align-items-center">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={enabledFields.supplierAutoSettlement}
                          onChange={() => handleToggleField('supplierAutoSettlement')}
                          color="primary"
                        />
                      }
                      title="فعال و قابل ویرایش"
                      labelPlacement="start"
                    />
                    <div style={{ marginLeft: '16px' }}>
                      <FormControlLabel
                        control={
                          <Controller
                            control={control}
                            name={"supplierAutoSettlement"}
                            render={({
                              field: { onChange, onBlur, value, name, ref },
                            }) => (
                              <Checkbox
                                color="primary"
                                onBlur={onBlur}
                                onChange={onChange}
                                checked={value || false}
                                disabled={!enabledFields.supplierAutoSettlement}
                                inputRef={ref}
                              />
                            )}
                          />
                        }
                        label="تسویه خودکار با تامین کننده"
                      />
                    </div>
                  </Col>
                  <Col xs="12" className="d-flex align-items-center">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={enabledFields.isActive}
                          onChange={() => handleToggleField('isActive')}
                          color="primary"
                        />
                      }
                      title="فعال و قابل ویرایش"
                      labelPlacement="start"
                    />
                    <div style={{ marginLeft: '16px' }}>
                      <FormControlLabel
                        control={
                          <Controller
                            control={control}
                            name={"isActive"}
                            render={({
                              field: { onChange, onBlur, value, name, ref },
                              fieldState: { invalid, isTouched, isDirty, error },
                            }) => (
                              <Checkbox
                                color="primary"
                                onBlur={onBlur}
                                onChange={onChange}
                                checked={value || false}
                                disabled={!enabledFields.isActive}
                                inputRef={ref}
                              />
                            )}
                          />
                        }
                        label="فعال"
                      />
                    </div>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="success" type="submit" disabled={isSubmitting || !Object.values(enabledFields).some(Boolean)}>
                {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                <SaveIcon /> ذخیره
              </Button>
              <Button variant="danger" onClick={handleClose}>
                <CloseIcon /> بستن
              </Button>
            </Modal.Footer>
          </form>
        </Modal>
      </div>
    </div>
  );
};

export default GroupEditingModal;
